module.exports = __webpack_public_path__ + "static/media/icon-globe.a54806e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-globe.svg
// module id = ./src/assets/images/icon-globe.svg
// module chunks = 0